import LogoOnLoginEN from './logo-on-login-en.svg'
import LogoOnLoginZH from './logo-on-login-zh.svg'
import LogoOnSidebarEN from './logo-on-sidebar-en.svg'
import LogoOnSidebarZH from './logo-on-sidebar-zh.svg'
import { getLocale } from 'ggx-src/legacy/utils/locale'

export default {
  StyledLogoOnLogin: () => {
    const currentLocale = getLocale()
    return currentLocale === 'zh-hk' ? (
      <LogoOnLoginZH style={{ height: '100%' }} />
    ) : (
      <LogoOnLoginEN style={{ height: '100%' }} />
    )
  },
  LogoOnSidebar: () =>
    getLocale() === 'zh-hk' ? <LogoOnSidebarZH /> : <LogoOnSidebarEN />,
}
